// import {useAuth0} from '@auth0/auth0-react'
import {useFlags} from 'launchdarkly-react-client-sdk'
import * as Sentry from '@sentry/react'
// import {getUserRoles} from './get-user-roles'
import {useSelector} from 'react-redux'
import {selectEffectiveRole} from '../app-store/selector'

function useUserRoles() {
  // const {user} = useAuth0()
  const flags = useFlags()
  const userRoles = useSelector(selectEffectiveRole)

  if (flags.frontendRoleMimic) {
    console.log('use LD:  ' + flags.frontendRoleMimic)
    Sentry.setUser({useLD: flags.frontendRoleMimic})
    return {roles: [flags.frontendRoleMimic]}
  }

  if (userRoles) {
    // const userRoles = getUserRoles(user)
    Sentry.setUser({useUser: userRoles})
    return {
      roles: userRoles,
    }
  }
  return {roles: []}
}

export {useUserRoles}
